<template>
  <div class="dashboard-container">
    <div class="page-inner page-inner-fill position-relative">
      <tasks-list @show-task="showTask"></tasks-list>
    </div>
    
    <div class="page-sidebar bg-light overflow-x-hidden pt-0">
      <task ref="task"
            :task="selectedTask"
            :readonly="readonly"
            @task-closed="detachTask"></task>
    </div>
    
    <portal-target name="modals"/>
    <portal-target name="task-modals-main"/>
    <portal-target name="task-modals"/>
    <portal-target name="extraModals"/>
    <portal-target name="funders-modals"/>
    <portal-target name="dictums-modals"/>
    <portal-target name="financing-modals"/>
    <portal-target name="commitments-modals"/>
    <portal-target name="protocol-modals"/>
    <portal-target name="reviewers-modal"/>
    <portal-target name="committees-modal"/>
    <portal-target name="commitments-modals"/>
  </div>
</template>

<script>
  import TasksList from '../components/tasks/TasksList'
  import Task from '../components/tasks/Task'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { AlertManager } from '../components/utils/AlertManager'
  
  export default {
    name: 'Dashboard',
    props: {
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      TasksList,
      Task,
    },
    beforeRouteEnter (to, from, next) {
      next(async vm => {
        await vm.renderTask(to.params)
      })
    },
    async beforeRouteUpdate (to, from, next) {
      await this.renderTask(to.params)
      
      next()
    },
    methods: {
      ...mapActions({
        getTask: 'tasks/getTask',
      }),
      
      ...mapMutations({
        removeTask: 'tasks/REMOVE_TASK',
        setTask: 'tasks/SET_TASK',
      }),
      
      async renderTask (params) {
        if (params.id) {
          this.$refs['task'].loading = true
          
          const response = await this.getTask({
            id: params.id,
            query: { ...this.$route.query },
          })
          
          this.$refs['task'].loading = false
          
          if (response.status === 'error') {
            AlertManager.error(response.error)
            
            setTimeout(() => {
              //location.href = '/'
            }, 3600)
          }
        }
      },
      async showTask (task) {
        if (this.$router.currentRoute.params && parseInt(this.$router.currentRoute.params.id) !== parseInt(task.id)) {
          await this.$router.push({
            name: 'dashboard',
            params: {
              section: 'tarea',
              id: task.id,
            },
            query: { ...this.$route.query },
          })
        }
      },
      async detachTask (task) {
        // Remove task from list os tasks.
        this.removeTask(task)
        this.setTask(null)
        
        return await this.$router.push({ name: 'dashboard' })
      },
    },
    computed: {
      ...mapGetters({
        selectedTask: 'tasks/selectedTask',
      }),
    },
  }
</script>
